// src/pages/ResourceDetail.jsx
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { articles } from '../data/articlesData';
import { articles } from '../components/Resources/articlesData';
import DigitalHealthFAB from '../components/Digitalhealth';

const ResourceDetail = () => {
  const { slug } = useParams();
  const location = useLocation();
  const pageUrl = `${window.location.origin}${location.pathname}`;
  const navigate = useNavigate();
  const article = articles.find((a) => a.slug === slug);
  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)},
      "_blank",
      "width=600,height=500"`)
  }
  const shareWhatsapp = () => {
    window.open(
      `https://wa.me/?text=${encodeURIComponent(pageUrl)}`,
      "_blank"
    );
  };
  if (!article) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white">
        <p className="ava-heading-lg mb-4">Article not found.</p>
        <button className="btn-primary" onClick={() => navigate('/resources')}>
          Back to Resources
        </button>
      </div>
    );
  }

  return (
    <>
      <DigitalHealthFAB />
      <div className="min-h-screen bg-white">
        <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">

          {/* Back button */}

          {/* Hero image */}
          <img
            src={article.image}
            alt={article.title}
            className="w-full rounded-2xl object-cover mb-6"
            style={{ maxHeight: '400px' }}
          />

          {/* Meta */}
          <div className="mb-3 flex items-center gap-3">
            <span className="ava-text-caption ava-card-bg rounded-md py-0.5 px-2">
              {article.tag}
            </span>
            <span className="ava-text-caption" style={{ color: 'var(--gray-500)' }}>
              {article.readTime}
            </span>
          </div>

          {/* Title */}
          <h1 className="ava-heading-lg mb-6">{article.title}</h1>

          {/* Content */}
          <div
            className="ava-text-body prose max-w-none"
            style={{ lineHeight: '1.8' }}
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

        </div>
      </div>
      {/* <div className='flex items-center flex-col gap-4 m-5'>
        <div>Share</div>
        <div className='' >
          <button className='' onClick={shareFacebook}>
            <img src="/Home/facebook.svg" alt="Google Play" className="h-6 w-6" />
          </button>
        </div>
      </div> */}
    </>
  );
};

export default ResourceDetail;